import { render, staticRenderFns } from "./FiduciaDetail.vue?vue&type=template&id=7653c6da&scoped=true&"
import script from "./FiduciaDetail.vue?vue&type=script&lang=js&"
export * from "./FiduciaDetail.vue?vue&type=script&lang=js&"
import style0 from "./FiduciaDetail.vue?vue&type=style&index=0&id=7653c6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653c6da",
  null
  
)

export default component.exports